export type Home = {
  id: number;
  name: string;
  country?: string;
  target_power_not_compensated?: number | null;
  saving_per_self_consumed_kwh?: number | string | null;
  selling_price_exported_kwh?: number | string | null;
  buying_price_imported_kwh?: number | string | null;
  receive_energy_report_emails?: boolean;
  inverter_on_phase_1?: "UNKNOWN" | "YES" | "NO";
  inverter_on_phase_2?: "UNKNOWN" | "YES" | "NO";
  inverter_on_phase_3?: "UNKNOWN" | "YES" | "NO";
  user_email?: string;
  user_first_name?: string;
  user_last_name?: string;
};

export function isHomeDetailLoaded(home: Home | undefined | null): boolean {
  return !!home && "dongle_ip" in home;
}
